import React from 'react';

function BannerPage() {
  return (
    <div style={{ background: 'orange', color: 'white', textAlign: 'center', padding: '10px' }}>
      For demonstration purposes only at the moment. Don't plan your live games with it yet!
    </div>
  );
}

export default BannerPage;
